import "./integrations.css";
import { Fragment, useEffect } from "react";
import Helmet from "react-helmet";
import TinyTitle from "../../components/tinytitle/TinyTitle";
import makeLogo from "../../assets/images/make-logo.png";
// import slackLogo from "../../assets/images/slack-logo.png";
// import githubLogo from "../../assets/images/github-logo.png";

const integrations = [
    {
        name: "Make",
        description:
            "Automate secure workflows with SharePass using Make.com. Connect SharePass to thousands of apps and create secure sharing flows without manual steps.",
        link: "https://www.make.com/en/integrations/sharepass?utm_source=sharepass-app&utm_medium=partner&utm_campaign=partner-listing",
        logo: makeLogo
    }

    /*
    Future integration template:
    ,{
        name: "Slack",
        description:
            "Securely share sensitive information inside Slack workflows with SharePass.",
        link: "https://your-link-here.com",
        logo: slackLogo
    }
    */
];

const Integrations = () => {
    useEffect(() => {
        setTimeout(() => window.scrollTo(0, 0), 500);
    }, []);

    return (
        <Fragment>
            <Helmet>
                <title>Integrations | SharePass</title>
                <meta
                    name="description"
                    content="Explore SharePass integrations and connect secure workflows with Make.com."
                />
                <meta property="og:title" content="Integrations | SharePass" />
                <meta
                    property="og:description"
                    content="Explore SharePass integrations and connect secure workflows with Make.com."
                />
            </Helmet>

            <section className="integrations_page">
                <div className="content_sec">
                    <div className="integrations_wrap">
                        <div className="integrations_heading">
                            <TinyTitle title="Connect SharePass with your tools" />
                            <h1>Integrations</h1>
                            <p className="integrations_intro">
                                Explore the platforms that work with SharePass and bring
                                secure sharing into your existing workflows.
                            </p>
                        </div>

                        <div className="integrations_list_wrap">
                            <div className="integrations_list">
                                {integrations.map((integration, index) => (
                                    <a
                                        key={index}
                                        href={integration.link}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="integration_item"
                                    >
                                        <div className="integration_item_logo">
                                            <img
                                                src={integration.logo}
                                                alt={`${integration.name} logo`}
                                            />
                                        </div>

                                        <div className="integration_item_content">
                                            <h2>{integration.name}</h2>
                                            <p>{integration.description}</p>
                                        </div>

                                        <div className="integration_item_arrow">
                                            <span>→</span>
                                        </div>
                                    </a>
                                ))}
                            </div>

                            <p className="integrations_coming_soon">
                                More integrations coming soon.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    );
};

export default Integrations;